export interface Selectable {
  id?: number;
  selected?: boolean;
  expanded?: boolean;
  x: number;
  y: number;
  discriminator: DISCRIMINATOR;
  isChanged: boolean;
  update(newX: number, newY: number): void;
}

export enum DISCRIMINATOR {
  SN3 = 'SN3',
  SN3_UPGRADE = 'SN3_UPGRADE',
  EM_DRIVER = 'EM_DRIVER',
  LUMINAIRE = 'LUMINAIRE',
  PN = 'PN',
  HIM84 = 'HIM84',
  HCD405 = 'HCD405',
  HCD038 = 'HCD038',
  FUJITSU_ENV = 'FUJITSU_ENV',
  FUJITSU_ENV_CO2 = 'FUJITSU_ENV_C02'
}

export enum UserFriendlyDiscriminator {
  SN3 = 'SN3',
  SN3_UPGRADE = 'SN3+',
  PN = 'PN',
  HIM84 = 'HB',
  HCD405 = 'MW',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  HCD038 = 'MW'
}

const emergencyLightingNodeDiscriminators = new Set<DISCRIMINATOR>([
  DISCRIMINATOR.PN,
  DISCRIMINATOR.SN3,
  DISCRIMINATOR.SN3_UPGRADE,
  DISCRIMINATOR.HIM84,
  DISCRIMINATOR.HCD405,
  DISCRIMINATOR.HCD038
]);

export function isEmergencyLightingNodeDiscriminator(discriminator: DISCRIMINATOR | undefined): boolean {
  return discriminator != null && emergencyLightingNodeDiscriminators.has(discriminator);
}

export function getDistinctUserFriendlyDiscriminators(): string[] {
  return Array.from(new Set(Object.values(UserFriendlyDiscriminator)));
}
